import { Component } from '@angular/core';

@Component({
  selector: 'app-change-user',
  templateUrl: './change-user.component.html',
  styleUrls: ['./change-user.component.scss'],
  standalone: false
})
export class ChangeUserComponent {
  public canBecomeUser = true;
  public canBookOnBehalf = true;
  public showType = 'become';
  constructor() {}

  log(data): void {
    console.log(data);
  }
}
